import { ROUTE_NAMES_LEGACY_JSD_WIDGETS } from '@atlassian/jira-common-constants/src/spa-routes';

export const legacyJsdWidgetsRoute = {
	name: ROUTE_NAMES_LEGACY_JSD_WIDGETS,
	path: '/servicedesk/admin/:projectKey/addon/:addonName',
	exact: true,
};
